import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const AnoDesdeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DESDE' htmlFor='input-anoDesde' md={12} />
      <Col md={12}>
        <Field name='anoDesde'>
          {({ field }) => (
            <Form.InputNumber {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-anoDesde' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AnoDesdeFormGroup)
